import { ChangeEvent, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import UnitsNavBar from "./UnitsNavBar";

const AddUnit = () => {
	const [unit, setUnit] = useState("")
	const [msg, setMsg] = useState("")
	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		setUnit(event.target.value)
	}

	const addUnit = async () => {
		if (unit !== "") {
			const payload = {"unit": unit, paid: document.getElementById("paid") ? (document.getElementById("paid") as HTMLInputElement).checked : false}
			try {
				const response = await fetch(process.env.REACT_APP_API+"/api/units", {
					method: "POST",
					body: JSON.stringify(payload)
				})
				const msg = await response.json()
				setMsg(msg.msg)
				setUnit("")
			} catch(e) {
				console.log(e)
			}
		} else {
			setMsg("Unit name cannot be empty")
		}
	}
	
	return (
		<div className="resilire">
			<AdminNavBar />
			<UnitsNavBar />
			<label htmlFor="unit">Unit Name</label>
			<input id="unit" value={unit} onChange={handleChange} />
			<label htmlFor="paid">Is Unit Paid?</label>
			<div>
				<input id="paid" type="checkbox" value="true" />
				<label htmlFor="paid"> Yes</label>
			</div>

			<button onClick={addUnit}>Add&nbsp;Unit</button>
			{msg && (
				<div>
					{msg}
				</div>
			)}
		</div>
	)
};
export default AddUnit;
